module.exports = __webpack_public_path__ + "media/audio23.036c1b10.wav";